<template>
  <div class="fixed bottom-6 right-6 z-[49]">
    <UPopover
      mode="hover"
    >
      <UButton
        color="primary"
        icon="ri:chat-2-fill"
        aria-label="Message Us"
        size="xl"
      />

      <template #panel>
        <div class="p-4 flex items-center justify-center gap-2">
          <UButton
            color="white"
            variant="ghost"
            size="xl"
            icon="ri:whatsapp-fill"
            class="inline-flex items-center justify-center text-green-500 hover:bg-green-500 hover:text-white"
            @click="openLink('whatsapp')"
          />
          <UButton
            color="white"
            variant="ghost"
            size="xl"
            icon="ri:facebook-fill"
            class="inline-flex items-center justify-center text-primary hover:bg-primary hover:text-white"
            @click="openLink('facebook')"
          />
        </div>
      </template>
    </UPopover>
  </div>
</template>

<script setup lang="ts">
const whatsappLink = 'https://wa.me/447823336196'
const facebookLink = 'https://m.me/GrampianBusinessFinderGOLD'

function openLink(platform: string) {
  let url = ''
  if (platform === 'whatsapp') {
    url = whatsappLink
  }
  else if (platform === 'facebook') {
    url = facebookLink
  }
  window.open(url, '_blank')
}
</script>

<style scoped>

</style>
